import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { getDurationInSeconds } from "../../../utils/DateServices";

interface CombineResultItemProps {
    answer: AnswerResult,
}

function CombineResultItem(props: CombineResultItemProps): JSX.Element {

    let answerValue = props.answer.value;

    if (answerValue[answerValue.length - 1] === ";") {
        answerValue = answerValue.slice(0, answerValue.length - 1)
    }

    const answers: string[] = answerValue.split(";");

    let correctValue = props.answer.item.correct;
    if (correctValue[correctValue.length - 1] === ";") {
        correctValue = correctValue.slice(0, correctValue.length - 1)
    }

    let answerElements = [];

    for (let i: number = 0; i < answers.length; i++) {
        let answerArray = answers[i].split("|", 2);
        let ans = answerArray[0] !== "" ? answerArray[0] : "tyhjä";
        let correct = answerArray[1];
        let isCorrect = ans === correct ? true : false;
        let correctColor = isCorrect ? "text-green-500" : "text-red-500";
       
        answerElements.push(
            <div className={correctColor + ""} key={"answer_" + props.answer.id + "_" + i} >{ans + " - " + correct}</div>
        );
    }

    const start = new Date(Date.parse(props.answer.start_time));
    const end = new Date(Date.parse(props.answer.end_time));
    const answerDuration = getDurationInSeconds(end, start);

    let answerTime = <span className="text-center my-auto pb-1" key={"answerTime-" + props.answer.id}>{answerDuration + ' s'}</span>

    return (
        <div className="pb-1 mt-1 grid grid-cols-2 border-b border-teal-100">
            <div className="" key={"answerElements" + props.answer.id} >{answerElements}</div>
            <div className="ml-10 pl-5" key={"answerTimeDiv" + props.answer.id}>{answerTime}</div>
        </div>
    );
}

export default CombineResultItem;